import DayEndQueries from './DayEndQueries'

const mvPaymentRequests = {
  mvPaymentRequests: {
    ...DayEndQueries
  }
}

export default mvPaymentRequests